<template>
  <div class="w-full">
    <label class="block text-lg font-bold text-gray-700 mb-1">{{ label }}</label>
    <a-select
        v-model:value="teamId"
        ref="select"
        class="block shadow w-full"
        @change="switchToTeam($event)"
    >
      <a-select-option v-if="$page.props.user.all_teams" v-for="team in $page.props.user.all_teams" :key="team.id"
                       :value="String(team.id)"> {{
          team.name
        }}
      </a-select-option>

      <a-select-option value="null" v-if="teamId ==='null'"> No Team Selected
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
import {Inertia} from "@inertiajs/inertia";

export default {
  props: {
    showPublic: {
      default: false
    },
    label: {
      default: 'Team:'
    }
  },
  data() {

    return {
      teamId: String(this.$page.props.user.current_team_id)
    }
  },
  components: {},
  methods: {
    switchToTeam(team) {
      this.$inertia.put(
          route("current-team.update"),
          {
            team_id: team.id,
          },
          {
            preserveState: false,
          }
      );
    },
  },
  setup(props, {emit}) {

    const switchToTeam = (team) => {
      Inertia.put(
          route("current-team.update"),
          {
            team_id: team,
          },
          {
            preserveState: false,
          }
      );
    }
    return {
      switchToTeam
    };
  }
}
</script>
